import React, { Fragment } from 'react'
import uuidv4 from 'uuid/v4'

import { wrapText } from '../../lib/formats'

const PlainText = props => {
  const style = Object.assign(
    { fontFamily: ['Roboto', 'sans-serif'] },
    props.style
  )
  const displayText = props.wrapText
    ? wrapText(props.text, Number(props.wrapText))
    : props.text

  const TextWithLineBreaks = ({ text }) => (
    <article style={style}>
      {text.split('\n').map(line => (
        <Fragment key={uuidv4()}>
          {line}
          <br />
        </Fragment>
      ))}
    </article>
  )

  return <TextWithLineBreaks text={displayText} />
}

export default PlainText



// WEBPACK FOOTER //
// ./src/components/UI/PlainText.jsx